module.exports = __webpack_public_path__ + "e00bc62328db0bcb4cce09238cf83ae8.svg";